import React, { Component } from 'react';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import AboutPage from './AboutPage';
import Home from './Home';
import First from './First';
import Second from './Second';
import Third from './Third';
import Eighth from './eighth';
import Fifth from './fifth';
import Fourth from './fourth';
import Fourth1 from './fourth1';
import Fourth2 from './fourth2';
import Fourth3 from './fourth3';
import Fourth4 from './fourth4';
import Fourth5 from './fourth5';
import Fourth6 from './fourth6';
import Fourth7 from './fourth7';
import Fourth8 from './fourth8';
import Fourth9 from './fourth9';
import Ninth from './ninth';
import Seventh from './seventh';
import Tenth from './tenth';
import Second1 from './second1';
import Second2 from './second2';
import Second3 from './second3';
import Second4 from './second4';
import Second5 from './second5';
import Second6 from './second6';
import Second7 from './second7';
import Second8 from './second8';
import Second9 from './second9';
import Second11 from './second11';
import Second12 from './second12';
import Second13 from './second13';
import Second21 from './second21';
import Second22 from './second22';
import Second23 from './second23';
import Second24 from './second24';
import Second31 from './second31';
import Second32 from './second32';
import Second33 from './second33';
import Second34 from './second34';
import Second41 from './second41';
import Second42 from './second42';
import Second51 from './second51';
import Second52 from './second52';
import Second53 from './second53';
import Second61 from './second61';
import Second62 from './second62';
import Second71 from './second71';
import Second72 from './second72';
import Second81 from './second81';
import Second91 from './second91';
import Second92 from './second92';
import Second93 from './second93';
import Sixth from './sixth';

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Routes>
          <Route path="/home" Component={Home} />
          <Route path="/" Component={First} />
          <Route path="/third" Component={Third} />
          <Route path="/second" Component={Second} />
          <Route path="/about" Component={AboutPage} />
          <Route path="/eighth" Component={Eighth} />
          <Route path="/fifth" Component={Fifth} />
          <Route path="/fourth" Component={Fourth} />
          <Route path="/fourth1" Component={Fourth1} />
          <Route path="/fourth2" Component={Fourth2} />
          <Route path="/fourth3" Component={Fourth3} />
          <Route path="/fourth4" Component={Fourth4} />
          <Route path="/fourth5" Component={Fourth5} />
          <Route path="/fourth6" Component={Fourth6} />
          <Route path="/fourth7" Component={Fourth7} />
          <Route path="/fourth8" Component={Fourth8} />
          <Route path="/fourth9" Component={Fourth9} />
          <Route path="/ninth" Component={Ninth} />
          <Route path="/seventh" Component={Seventh} />
          <Route path="/tenth" Component={Tenth} />
          <Route path="/second1" Component={Second1} />
          <Route path="/second2" Component={Second2} />
          <Route path="/second3" Component={Second3} />
          <Route path="/second4" Component={Second4} />
          <Route path="/second5" Component={Second5} />
          <Route path="/second6" Component={Second6} />
          <Route path="/second7" Component={Second7} />
          <Route path="/second8" Component={Second8} />
          <Route path="/second9" Component={Second9} />
          <Route path="/second11" Component={Second11} />
          <Route path="/second12" Component={Second12} />
          <Route path="/second13" Component={Second13} />
          <Route path="/second21" Component={Second21} />
          <Route path="/second22" Component={Second22} />
          <Route path="/second23" Component={Second23} />
          <Route path="/second24" Component={Second24} />
          <Route path="/second31" Component={Second31} />
          <Route path="/second32" Component={Second32} />
          <Route path="/second33" Component={Second33} />
          <Route path="/second34" Component={Second34} />
          <Route path="/second41" Component={Second41} />
          <Route path="/second42" Component={Second42} />
          <Route path="/second51" Component={Second51} />
          <Route path="/second52" Component={Second52} />
          <Route path="/second53" Component={Second53} />
          <Route path="/second61" Component={Second61} />
          <Route path="/second62" Component={Second62} />
          <Route path="/second71" Component={Second71} />
          <Route path="/second72" Component={Second72} />
          <Route path="/second81" Component={Second81} />
          <Route path="/second91" Component={Second91} />
          <Route path="/second92" Component={Second92} />
          <Route path="/second93" Component={Second93} />
          <Route path="/sixth" Component={Sixth} />
        </Routes>
      </HashRouter>
    );
  }
}

export default App;
